import React, { useEffect, useState } from 'react'
import { PriceListItem } from '../../../../services/PriceListApi'
import { Currency } from '../../../models'
import { CurrencyLabel } from '../../../ui/currency'
import { Formik, Form, Field } from 'formik'
import { Overlay } from '../../../elements/Overlay'
import { useOfferionTranslation } from '../../../store/hooks/useOfferionTranslation'

interface Props {
    onCloseButtonClicked: () => void
    currency: Currency
    selectedProductComponent: React.ComponentType<{ selectedProduct: PriceListItem }>
    allowGroupSelection?: boolean
    priceListPromise: (groupId: number | null, searchString: string | null) => Promise<PriceListItem[]>
}

export const PriceListModalForm = (props: Props) => {
    const { t } = useOfferionTranslation()

    const [priceListItems, setPriceListItems] = useState<PriceListItem[]>([])
    const [groupId, setGroupId] = useState<number | null>(null)
    const [searchString, setSearchString] = useState<string | null>(null)
    const [selectedProduct, setSelectedProduct] = useState<PriceListItem | null>(null)
    const [selectedGroups, setSelectedGroups] = useState<PriceListItem[]>([])

    useEffect(() => {
        setSelectedProduct(null)
        setPriceListItems([])

        props.priceListPromise(groupId, searchString).then(result => {
            setPriceListItems(result)
        })
    }, [searchString, groupId])

    const goBackInHierarchy = () => {
        if (selectedGroups.length === 0) return

        const newSelectedGroups = selectedGroups.slice(0, -1)
        setSelectedGroups(newSelectedGroups)
        setPriceListItems([])
        setSearchString(null)

        if (newSelectedGroups.length === 0) {
            setGroupId(null)
        } else {
            setGroupId(newSelectedGroups[newSelectedGroups.length - 1].groupId || null)
        }
    }

    const goToGroup = (item: PriceListItem) => {
        setGroupId(item.groupId!)
        setPriceListItems([])
        setSearchString(null)
        setSelectedGroups([...selectedGroups, item])
    }

    const elements = priceListItems
        .filter(x => selectedProduct == null || x == selectedProduct)
        .map((item, index) => {
            return (
                <li className="table__row" key={`${item.groupId}-${item.productId}`}>
                    <span className="table__cell__title table__cell__title--full-width">
                        {item.productId && (
                            <span>
                                <span
                                    className="icon icon__item cursor-pointer"
                                    onClick={() => setSelectedProduct(selectedProduct ? null : item)}
                                ></span>
                                <span className="cursor-pointer" onClick={() => setSelectedProduct(selectedProduct ? null : item)}>
                                    {item.name}
                                    {item.code ? <span className="mod-margin-left-4">[{item.code}]</span> : null}
                                </span>
                                <CurrencyLabel
                                    className="mod-margin-left-4 price-list-amount"
                                    amount={item.price}
                                    currency={props.currency}
                                />
                                <input
                                    id={`selected-product-${index}`}
                                    type="checkbox"
                                    className="checkbox"
                                    checked={selectedProduct == item}
                                />
                                <label
                                    htmlFor={`selected-product-${index}`}
                                    onClick={() => setSelectedProduct(selectedProduct ? null : item)}
                                    className="button button--gray button--padded checkbox-button button--print  mod-margin-left-4"
                                >
                                    <span className="checkbox-button__icon"></span>
                                </label>
                            </span>
                        )}
                        {item.groupId && (
                            <span
                                style={{ cursor: item.numberOfElements ? 'pointer' : 'default' }}
                                onClick={() => item.groupId && item.numberOfElements && goToGroup(item)}
                            >
                                <span className="icon icon__group"></span>
                                <span>{item.name}</span>
                            </span>
                        )}
                        {!!item.numberOfElements && (
                            <span className="table__cell__item-count mod-margin-left-4">({item.numberOfElements})</span>
                        )}
                        {item.groupId && props.allowGroupSelection ? (
                            <>
                                <input id={`selected-group-${index}`} type="checkbox" className="checkbox" />
                                <label
                                    htmlFor={`selected-group-${index}`}
                                    onClick={() => setSelectedProduct(selectedProduct ? null : item)}
                                    className="button button--gray button--padded checkbox-button button--print mod-margin-left-4"
                                >
                                    <span className="checkbox-button__icon"></span>
                                </label>
                            </>
                        ) : null}
                    </span>
                </li>
            )
        })

    return (
        <Overlay>
            <h1 className="overlay__title">{t('Invoice.Table.buttonNewFromPricelist')}</h1>
            <button type="button" className="button overlay__close" data-hook="close-overlay" onClick={props.onCloseButtonClicked}>
                <span className="icono-cross"></span>
            </button>

            <div className="info__container">
                <div className="info__row">
                    <label className="info__row-name">{t('Header.search')}</label>

                    <div className="info__row-content info__row-content--extended">
                        <Formik
                            initialValues={{ searchString: searchString || '' }}
                            onSubmit={({ searchString }) => {
                                setSearchString(searchString)
                            }}
                        >
                            <Form className="nav__search-container nav__search-container--responsive">
                                <Field
                                    autoFocus
                                    className="nav__search"
                                    type="text"
                                    placeholder="Dio naziva proizvoda"
                                    name="searchString"
                                />

                                <div className="nav__search-buton-container">
                                    <button className="nav__search-button button--blue" type="submit">
                                        <span className="icon icon__search"></span>
                                    </button>
                                </div>
                            </Form>
                        </Formik>
                    </div>
                </div>

                <div className="table__wrapper">
                    <ul className="table" data-hook="stop-propagation">
                        {selectedGroups.length > 0 && (
                            <li className="table__row" style={{ cursor: 'pointer', minHeight: '55px' }}>
                                <>
                                    <span className="overlay__item overlay__item--right-middle"></span>
                                    <span
                                        onClick={goBackInHierarchy}
                                        className="table__cell table__cell__title table__cell__icon mod-cursor-pointer"
                                    >
                                        <span className="icon icon__back"></span>

                                        {selectedGroups.length > 0 ? selectedGroups[selectedGroups.length - 1].name : null}
                                    </span>
                                    {/* 
                                        <span
                                              onClick={() => goBack(gridActions)}
                                              className="table__cell table__cell__icon mobile-only clickable">
                                              <span className="icon icon__back"></span>
                                          </span> */}

                                    {/* <span
                                              onClick={goBackInHierarchy}
                                              className="">
                                                {selectedGroups.length > 0 ? selectedGroups[selectedGroups.length - 1].name : null}
                                          </span> */}
                                </>
                            </li>
                        )}
                        {elements}
                    </ul>
                </div>

                {selectedProduct && React.createElement(props.selectedProductComponent, { selectedProduct })}
            </div>
        </Overlay>
    )
}
